import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { fetchBooking } from "../../lib/api";

function Row({ label, children }) {
  return (
    <div className="grid grid-cols-[160px_1fr] gap-6 py-3 border-b border-white/5">
      <div className="text-xs uppercase tracking-[0.15em] text-white/40">{label}</div>
      <div className="text-sm">{children}</div>
    </div>
  );
}

export default function BookingDetailPage() {
  const { id } = useParams();
  const [booking, setBooking] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchBooking(id)
      .then((b) => setBooking(b || null))
      .catch((err) => setError(err?.message || "Errore"));
  }, [id]);

  return (
    <div className="p-8 lg:p-12 max-w-3xl" data-testid="admin-booking-detail">
      <Link
        to="/admin"
        className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.15em] text-white/50 hover:text-white mb-8"
      >
        <ArrowLeft size={14} weight="bold" />
        Tutte le prenotazioni
      </Link>

      {error && <div className="border border-red-500/40 px-4 py-3 text-red-300">{error}</div>}
      {!booking && !error && <div className="text-white/40 text-sm">Caricamento…</div>}
      {booking === null && !error && (
        <div className="text-white/50">Prenotazione non trovata.</div>
      )}

      {booking && (
        <div>
          <header className="mb-10">
            <div className="text-xs uppercase tracking-[0.25em] text-[#C5A059] mb-2">
              Prenotazione
            </div>
            <h1 className="font-serif text-4xl lg:text-5xl leading-tight">{booking.name}</h1>
          </header>

          <div className="border border-white/10">
            <div className="px-6 py-2">
              <Row label="ID">{booking.id}</Row>
              <Row label="Nome">{booking.name}</Row>
              <Row label="Email">
                <a href={`mailto:${booking.email}`} className="text-[#C5A059] hover:underline">
                  {booking.email}
                </a>
              </Row>
              <Row label="Telefono">
                {booking.phone ? (
                  <a href={`tel:${booking.phone}`} className="text-[#C5A059] hover:underline">
                    {booking.phone}
                  </a>
                ) : (
                  <span className="text-white/30">—</span>
                )}
              </Row>
              <Row label="Check-in">{booking.check_in || "—"}</Row>
              <Row label="Check-out">{booking.check_out || "—"}</Row>
              <Row label="Ospiti">{booking.guests}</Row>
              <Row label="Camera">{booking.room_slug || <span className="text-white/30">—</span>}</Row>
              <Row label="Lingua">{booking.lang?.toUpperCase() || "—"}</Row>
              <Row label="Stato">{booking.status}</Row>
              <Row label="Ricevuta il">{booking.created_at || "—"}</Row>
              <Row label="Messaggio">
                {booking.message ? (
                  <div className="whitespace-pre-wrap text-white/80">{booking.message}</div>
                ) : (
                  <span className="text-white/30">(nessun messaggio)</span>
                )}
              </Row>
            </div>
          </div>

          <div className="mt-8 p-6 border border-white/10 bg-white/[0.02]">
            <div className="text-xs uppercase tracking-[0.15em] text-[#C5A059] mb-2">
              Prossimamente
            </div>
            <p className="text-sm text-white/60">
              In una prossima iterazione sarà possibile confermare, annullare o rispondere
              direttamente alla prenotazione da questa pagina.
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
